import { config } from '@uhg-abyss/web/tools/config';
import { http } from '@uhg-abyss/web/tools/http';
import { event as eapmEvent } from '@uhg-abyss/web/tools/event';
import { getTinStatusError, saveAsDraftError } from './errors';

export const callSaveAsDraft = async (payload) => {
  const { action } = payload;
  const response = await http({
    id: 'epv-tin-superusersavedraft',
    method: 'POST',
    cache: false,
    withCredentials: true,
    url: `${config('LINK_EPV_API_URL')}/superUser/draft/v1`,
    handleError: saveAsDraftError,
    body: action.payload,
  });
  const { duration, endpoint, status, data } = response;
  const successData = {
    endpoint,
    duration,
    status,
  };
  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);
  return data;
};

export const getDraft = async (payload) => {
  const { action } = payload;
  const { billingTin, optumId } = action.payload;

  const response = await http({
    id: 'epv-tin-getsuperusersaveddraft',
    method: 'GET',
    cache: false,
    withCredentials: true,
    url: `${config('LINK_EPV_API_URL')}/superUser/draft/v1`,
    handleError: getTinStatusError,
    query: {
      billingTin,
      optumId,
    },
  });
  const { duration, endpoint, status, data } = response;
  const successData = {
    endpoint,
    duration,
    status,
  };
  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);
  return data;
};
